import {
  UPDATE_USERS_LIST_DATA,
  UPDATE_USERS_LOADING,
} from "../../store/actionTypes";

const initialState = {
  total: 0,
  pageNo: 1,
  limit: 10,
  totalPage: 0,
  searchKey: "",
  sortOrder:1,
  sortBy:"name",
  usersList: [],
  isLoading: false,
};

/**
 *
 * @param {initial state of reducer} state
 * @param { perfoam actions } action
 * @returns update state of reducer
 */
const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USERS_LIST_DATA:
      return { ...state, ...action.payload };
    case UPDATE_USERS_LOADING:
      return { ...state, ...{ isLoading: !state.isLoading } };
    default:
      return {...state};
  }
};

export default UserReducer;
